import { Card, CardContent } from "../ui/card";
import { ChefLexAvatar } from "../ChefLexAvatar";
import { Badge } from "../ui/badge";

interface VoiceHintProps {
  message: string;
  voice?: "high" | "medium" | "low";
  className?: string;
}

export function VoiceHint({ message, voice = "medium", className = "" }: VoiceHintProps) {
  const getVoiceBadgeColor = () => {
    switch (voice) {
      case "high": return "bg-green-100 text-green-800 border-green-200";
      case "medium": return "bg-yellow-100 text-yellow-800 border-yellow-200";
      case "low": return "bg-blue-100 text-blue-800 border-blue-200";
      default: return "bg-stone/30 text-ink border-stone";
    }
  };

  return (
    <Card className={`border-muted bg-muted/30 ${className}`}>
      <CardContent className="p-3">
        <div className="flex items-start gap-3">
          <ChefLexAvatar size="sm" />
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-1">
              <span className="text-xs font-medium text-muted-foreground">Chef Lex</span>
              <Badge className={`text-xs ${getVoiceBadgeColor()}`}>
                {voice}
              </Badge>
            </div>
            <p className="text-sm text-muted-foreground">{message}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
